<template>
    <div v-if="showSizeInput" class="c-product-size-scope">
        <div class="c-product-size" :class="{'is-valid' : isValid, 'is-invalid': isInvalid, 'is-disabled': isDisabled || localLoading, 'is-preorder': isPreOrder}">
            <v-input v-if="item"  :disabled="isDisabled" :horizontal="false" type="integer" :min="0" :name="`${_uid}-product-size`" input-size="small" :value="item.Amount" v-model.number="item.Amount" @change="updateItem">
                <span slot="label" class="u-text-align-center u-block u-margin-bottom-tiny">{{item.Size}}</span>
            </v-input>

            <!-- The stock available -->
            <div v-if="item && typeof item.Stock !== 'undefined' || !item"
                    class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny"
                    :class="{'is-valid' : isValid, 'is-invalid': isInvalid}">

                <template v-if="item && item.Stock && !isMarketing">
                    <svgicon name="check" width=".8em" height=".8em" class="u-svg-color-success-base"></svgicon>
                    <span v-if="!isCustomerHidden">Stock: {{ item.Stock }}</span>
                    <span v-else>{{ item.StockIndication }}</span>
                </template>
                <template v-else-if="item && !isMarketing">
                    <svgicon name="cross" width=".6em" height=".6em" class="u-svg-color-alpha-base"></svgicon>
                    <span>{{ item.StockIndication }}</span>
                </template>

                <span v-if="(item.NextStockDelivery && !isMarketing) || showPreOrder" v-tooltip="{ content: getTooltip, classes: 'information' }">
                    <svgicon name="info" width="1em" height="1em" class="u-svg-color-info-base"></svgicon>
                </span>

                <!-- The supplier stock available -->
                <template v-if="item && typeof item.SupplierStock !== 'undefined' && item.SupplierStock !== null">
                    <span v-if="!isMarketing" 
                          v-tooltip="{
                            content: getFormattedStockInfoSupplier,
                            classes: 'information'
                        }">
                        <svgicon class="u-color-success-base" name="factory" width="1.3em" height="1.3em"></svgicon>
                        <span v-if="!isCustomerHidden">{{ item.SupplierStock }}</span>
                    </span>
                </template>

                <!-- The amount in the basket -->
                <template v-if="item && typeof item.BasketAmount !== 'undefined' && !isMarketing">
                    <span>
                        <svgicon name="shopping-cart" width="1.3em" height="1.3em"></svgicon>
                        <span>{{ item.BasketAmount }}</span>
                    </span>
                </template> 
            </div>
        </div>
    </div>
    <div v-else class="c-product-size-scope--empty"></div>
</template>

    <script>
        import debounce from 'lodash/debounce'
        import VInput from '@/components/form/Input'

        export default {
            components: {
                VInput
            },
            props: {
                item: Object,
                isAdmin: Boolean,
                disabled: { type: Boolean, default: false }
            },
            data() {
                return {
                    localLoading: false
                }
            },
            computed: {
                showSizeInput() {
                return this.item && (this.isPreOrder === false || this.$store.getters.isImpersonated === true) && this.item.StockStatus != 'NO';
                },
                isPreOrder() {
                    return this.item.StockStatus === 'PRE' || this.item.StockStatus === 'PRE2';
                },
                showPreOrder() {
                    return this.isPreOrder === true && this.$store.getters.isImpersonated === true;
                },
                preOrderStock() {
                    if(this.item.SupplierStock) {
                        return this.item.FutureAvailableStock + this.item.SupplierStock;
                    }

                    return this.item.FutureAvailableStock;
                },
                isValid() {
                    if (this.item && typeof this.item.Stock !== 'undefined' && this.item.Amount > 0) {
                        if(this.item.StockStatus == 'STOCK'
                        || this.item.StockStatus == 'OPB'
                        || this.item.StockStatus == 'NOS') {
                            return true;
                        } else if (this.showPreOrder === true) {
                            return this.item.Amount <= this.preOrderStock;
                        } else {
                            return this.item.Amount <= this.item.Stock;
                        }
                    }
                },
                isInvalid(){
                    if (this.item &&typeof this.item.Stock !== 'undefined') {
                        if(this.item.StockStatus == 'ZVS' || this.item.StockStatus == 'ZVS2' || this.item.StockStatus == 'OUT' || this.item.StockStatus == 'OUT2' || this.item.StockStatus == 'STOCK2') {
                            return this.item.Amount > this.item.Stock + this.item.SupplierStock;
                        } else if (this.showPreOrder === true) {
                            return this.item.Amount > this.preOrderStock;
                        } else {
                            return false;
                        }
                    }
                },
                isDisabled(){
                    if(this.disabled) return this.disabled;

                    if (typeof this.item.Stock !== 'undefined') {
                        return this.item
                        && ((this.isPreOrder && !(this.$store.getters.isImpersonated && this.preOrderStock > 0))
                            || this.item.StockStatus == 'NO'
                            || ((this.item.StockStatus == 'ZVS' || this.item.StockStatus == 'ZVS2') && !(this.item.Stock + this.item.SupplierStock > 0)));
                    } else {
                        return !(this.item.IsEnabled && this.item.IsAvailable);
                    }
                },
                isCustomer(){
                    return !this.$store.getters.userInfo.impersonated && 
                           (this.$store.getters.userInfo.role == "Klant" || this.$store.getters.userInfo.role == "PersoneelKlant" || this.$store.getters.userInfo.role == "MarketingKlant");
                },
                isCustomerHidden() {
                return this.$store.getters.isCustomerHidden;
                },
                isMarketing() {
                    return this.$store.getters.isMarketing;
                },
                getTooltip(){
                    let tooltip = '';

                    if(this.item.NextStockDelivery && !this.isMarketing){
                        tooltip += this.$t('customer.shop.detail.new_stock_available', {date: this.$moment(this.item.NextStockDelivery).format('DD-MM-YYYY')});
                    }

                    if(this.showPreOrder === true){
                        if(tooltip.length > 0){
                            tooltip += '<br/>';
                        }

                        tooltip += this.$t('customer.shop.detail.future_stock', {future_stock: this.item.FutureAvailableStock});
                    }
                    
                    return tooltip;
                },
                getFormattedStockInfoSupplier(){

                if(this.item.SupplierStock)
                {
                    var stock = this.item.SupplierStockIndication;

                    if(!this.isCustomerHidden)
                    {
                        stock = this.$t('customer.shop.detail.supplier_stock', {supplier_stock: this.item.SupplierStock});
                    }

                    return this.$t('customer.shop.detail.supplier_stock_delivery', {supplier_stock_indication: stock, supplier_days_to_deliver_min: this.item.SupplierDaysToDeliverMin, supplier_days_to_deliver_max: this.item.SupplierDaysToDeliverMax});

                } else {

                    if(this.item.NextStockSupplier)
                    {
                        return this.$t('customer.shop.detail.supplier_stock_next_delivery_date', {supplier_stock_indication: this.item.SupplierStockIndication, next_delivery_date: this.$moment(this.item.NextStockSupplier).format('DD-MM-YYYY')});
                    } else {
                        return this.item.SupplierStockIndication;
                    }
                }
            }
            },
            watch: {
              'item.Amount'() {
                  if (typeof this.item.Amount === 'string') {
                    this.item.Amount = 0;
                  }
              }
            },
            methods: {
                updateItem() {
                    this.$emit('update:item', this.item);
                }
            }
        }
    </script>

    <style lang="scss" scoped>
        @import "~@/assets/scss/private";

        .c-product-size-scope {
            margin-right: 10px;
            margin-bottom: 20px;

            .sizes-wrapper & {
                width: 15%;
                min-width: 120px;
            }

            &:last-child { margin-right: 0; }

            &--empty {
                width: 15%;
                margin-right: 10px;
                min-width: 120px;
            }
        }

        .c-product-size {
            border: 1px dashed palette(color-neutral, light);
            padding: em($global-spacing-unit-tiny);
            height: 125px;

            &.is-valid{
                border-color: $color-success;
                border-style: solid;
                background-color: rgba($color-success, .05);
            }

            &.is-invalid{
                border-color: $color-error;
                border-style: solid;
                background-color: rgba($color-error, .05);
            }

            &.is-disabled{
                opacity:.5;
            }
        }

        .c-product-size__stock{
            border: 1px solid transparent;
            font-size: 11px !important;
            &.is-invalid{
                border: 1px solid $color-error;
            }
        }

        .c-product-size__icons{ 
        > span{
            padding-right:5px;
            > span{
                vertical-align: middle;
                height:1em;
            }
        }
    }
    </style>

    <style lang="scss">

        @import "~@/assets/scss/private";

        .c-product-size {
            max-width: 110px;
            min-width: 80px;

            label {
                margin-bottom: em($global-spacing-unit-tiny);
            }

             &.is-preorder {
                input {
                    box-shadow: 0 0 0 3px $color-info !important;
                }
            }
        }

        .sizes-wrapper .c-product-size-toggle {
            width: 100% !important;
            height: 125px !important;
        }
    </style>




// WEBPACK FOOTER //
// src/components/shop/ShopProductPantsSizeInput.vue